/// Auto-generated. Modifications will be overwritten.
/// Generated from core/overriden-document-schemas/CheckDocumentModel.yaml
/** Check Document */
export class Check {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    /** type of check font */
    get fontType() {
        return this.document.fields.find((f) => f.type.name === 'FontType');
    }
    /** Detected raw string */
    get rawString() {
        return this.document.fields.find((f) => f.type.name === 'RawString');
    }
}
Check.FONT_TYPE_FIELD_NAME = 'FontType';
Check.FONT_TYPE_FIELD_NAME_NORMALIZED = 'Check.FontType';
Check.RAW_STRING_FIELD_NAME = 'RawString';
Check.RAW_STRING_FIELD_NAME_NORMALIZED = 'Check.RawString';
/** A check compatible with the ASC X9 standard used in the USA */
export class USACheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return USACheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Auxiliary On-Us field. For business checks this is often the serial number of the check. */
    get auxiliaryOnUs() {
        return this.document.fields.find((f) => f.type.name === 'AuxiliaryOnUs');
    }
    /** This field is often the check number, though it cannot be guaranteed as it is up to the discretion of the
  issuing bank.
   */
    get checkNumber() {
        return this.document.fields.find((f) => f.type.name === 'CheckNumber');
    }
    /** Transit number */
    get transitNumber() {
        return this.document.fields.find((f) => f.type.name === 'TransitNumber');
    }
}
USACheck.DOCUMENT_TYPE = 'USACheck';
USACheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
USACheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'USACheck.AccountNumber';
USACheck.AUXILIARY_ON_US_FIELD_NAME = 'AuxiliaryOnUs';
USACheck.AUXILIARY_ON_US_FIELD_NAME_NORMALIZED = 'USACheck.AuxiliaryOnUs';
USACheck.CHECK_NUMBER_FIELD_NAME = 'CheckNumber';
USACheck.CHECK_NUMBER_FIELD_NAME_NORMALIZED = 'USACheck.CheckNumber';
USACheck.TRANSIT_NUMBER_FIELD_NAME = 'TransitNumber';
USACheck.TRANSIT_NUMBER_FIELD_NAME_NORMALIZED = 'USACheck.TransitNumber';
/** A check format commonly used in the United Arab Emirates */
export class UAECheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return UAECheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Cheque number */
    get chequeNumber() {
        return this.document.fields.find((f) => f.type.name === 'ChequeNumber');
    }
    /** Routing number */
    get routingNumber() {
        return this.document.fields.find((f) => f.type.name === 'RoutingNumber');
    }
}
UAECheck.DOCUMENT_TYPE = 'UAECheck';
UAECheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
UAECheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'UAECheck.AccountNumber';
UAECheck.CHEQUE_NUMBER_FIELD_NAME = 'ChequeNumber';
UAECheck.CHEQUE_NUMBER_FIELD_NAME_NORMALIZED = 'UAECheck.ChequeNumber';
UAECheck.ROUTING_NUMBER_FIELD_NAME = 'RoutingNumber';
UAECheck.ROUTING_NUMBER_FIELD_NAME_NORMALIZED = 'UAECheck.RoutingNumber';
/** A check format commonly used in France */
export class FRACheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return FRACheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Cheque number */
    get chequeNumber() {
        return this.document.fields.find((f) => f.type.name === 'ChequeNumber');
    }
    /** Routing number */
    get routingNumber() {
        return this.document.fields.find((f) => f.type.name === 'RoutingNumber');
    }
}
FRACheck.DOCUMENT_TYPE = 'FRACheck';
FRACheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
FRACheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'FRACheck.AccountNumber';
FRACheck.CHEQUE_NUMBER_FIELD_NAME = 'ChequeNumber';
FRACheck.CHEQUE_NUMBER_FIELD_NAME_NORMALIZED = 'FRACheck.ChequeNumber';
FRACheck.ROUTING_NUMBER_FIELD_NAME = 'RoutingNumber';
FRACheck.ROUTING_NUMBER_FIELD_NAME_NORMALIZED = 'FRACheck.RoutingNumber';
/** A check format commonly used in Israel */
export class ISRCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return ISRCheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Bank number */
    get bankNumber() {
        return this.document.fields.find((f) => f.type.name === 'BankNumber');
    }
    /** Branch number */
    get branchNumber() {
        return this.document.fields.find((f) => f.type.name === 'BranchNumber');
    }
    /** Cheque number */
    get chequeNumber() {
        return this.document.fields.find((f) => f.type.name === 'ChequeNumber');
    }
}
ISRCheck.DOCUMENT_TYPE = 'ISRCheck';
ISRCheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
ISRCheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'ISRCheck.AccountNumber';
ISRCheck.BANK_NUMBER_FIELD_NAME = 'BankNumber';
ISRCheck.BANK_NUMBER_FIELD_NAME_NORMALIZED = 'ISRCheck.BankNumber';
ISRCheck.BRANCH_NUMBER_FIELD_NAME = 'BranchNumber';
ISRCheck.BRANCH_NUMBER_FIELD_NAME_NORMALIZED = 'ISRCheck.BranchNumber';
ISRCheck.CHEQUE_NUMBER_FIELD_NAME = 'ChequeNumber';
ISRCheck.CHEQUE_NUMBER_FIELD_NAME_NORMALIZED = 'ISRCheck.ChequeNumber';
/** A check format commonly used in Kuwait */
export class KWTCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return KWTCheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Cheque number */
    get chequeNumber() {
        return this.document.fields.find((f) => f.type.name === 'ChequeNumber');
    }
    /** Sort code */
    get sortCode() {
        return this.document.fields.find((f) => f.type.name === 'SortCode');
    }
}
KWTCheck.DOCUMENT_TYPE = 'KWTCheck';
KWTCheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
KWTCheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'KWTCheck.AccountNumber';
KWTCheck.CHEQUE_NUMBER_FIELD_NAME = 'ChequeNumber';
KWTCheck.CHEQUE_NUMBER_FIELD_NAME_NORMALIZED = 'KWTCheck.ChequeNumber';
KWTCheck.SORT_CODE_FIELD_NAME = 'SortCode';
KWTCheck.SORT_CODE_FIELD_NAME_NORMALIZED = 'KWTCheck.SortCode';
/** A check compatible with the Australian Paper Clearing System cheque standard */
export class AUSCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return AUSCheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Auxiliary domestic */
    get auxDomestic() {
        return this.document.fields.find((f) => f.type.name === 'AuxDomestic');
    }
    /** BSB */
    get bsb() {
        return this.document.fields.find((f) => f.type.name === 'BSB');
    }
    /** Extra auxiliary domestic */
    get extraAuxDomestic() {
        return this.document.fields.find((f) => f.type.name === 'ExtraAuxDomestic');
    }
    /** Transaction code */
    get transactionCode() {
        return this.document.fields.find((f) => f.type.name === 'TransactionCode');
    }
}
AUSCheck.DOCUMENT_TYPE = 'AUSCheck';
AUSCheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
AUSCheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'AUSCheck.AccountNumber';
AUSCheck.AUX_DOMESTIC_FIELD_NAME = 'AuxDomestic';
AUSCheck.AUX_DOMESTIC_FIELD_NAME_NORMALIZED = 'AUSCheck.AuxDomestic';
AUSCheck.BSB_FIELD_NAME = 'BSB';
AUSCheck.BSB_FIELD_NAME_NORMALIZED = 'AUSCheck.BSB';
AUSCheck.EXTRA_AUX_DOMESTIC_FIELD_NAME = 'ExtraAuxDomestic';
AUSCheck.EXTRA_AUX_DOMESTIC_FIELD_NAME_NORMALIZED = 'AUSCheck.ExtraAuxDomestic';
AUSCheck.TRANSACTION_CODE_FIELD_NAME = 'TransactionCode';
AUSCheck.TRANSACTION_CODE_FIELD_NAME_NORMALIZED = 'AUSCheck.TransactionCode';
/** A check compatible with the CTS-2010 standard issued by the Reserve Bank of India in 2012 */
export class INDCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return INDCheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Serial number */
    get serialNumber() {
        return this.document.fields.find((f) => f.type.name === 'SerialNumber');
    }
    /** Sort number */
    get sortNumber() {
        return this.document.fields.find((f) => f.type.name === 'SortNumber');
    }
    /** Transaction code */
    get transactionCode() {
        return this.document.fields.find((f) => f.type.name === 'TransactionCode');
    }
}
INDCheck.DOCUMENT_TYPE = 'INDCheck';
INDCheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
INDCheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'INDCheck.AccountNumber';
INDCheck.SERIAL_NUMBER_FIELD_NAME = 'SerialNumber';
INDCheck.SERIAL_NUMBER_FIELD_NAME_NORMALIZED = 'INDCheck.SerialNumber';
INDCheck.SORT_NUMBER_FIELD_NAME = 'SortNumber';
INDCheck.SORT_NUMBER_FIELD_NAME_NORMALIZED = 'INDCheck.SortNumber';
INDCheck.TRANSACTION_CODE_FIELD_NAME = 'TransactionCode';
INDCheck.TRANSACTION_CODE_FIELD_NAME_NORMALIZED = 'INDCheck.TransactionCode';
/** A check format commonly used in Canada */
export class CANCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return CANCheck.DOCUMENT_TYPE;
    }
    /** Account number */
    get accountNumber() {
        return this.document.fields.find((f) => f.type.name === 'AccountNumber');
    }
    /** Bank number */
    get bankNumber() {
        return this.document.fields.find((f) => f.type.name === 'BankNumber');
    }
    /** Cheque number */
    get chequeNumber() {
        return this.document.fields.find((f) => f.type.name === 'ChequeNumber');
    }
    /** Designation number */
    get designationNumber() {
        return this.document.fields.find((f) => f.type.name === 'DesignationNumber');
    }
    /** Transaction code */
    get transactionCode() {
        return this.document.fields.find((f) => f.type.name === 'TransactionCode');
    }
    /** Transit number */
    get transitNumber() {
        return this.document.fields.find((f) => f.type.name === 'TransitNumber');
    }
}
CANCheck.DOCUMENT_TYPE = 'CANCheck';
CANCheck.ACCOUNT_NUMBER_FIELD_NAME = 'AccountNumber';
CANCheck.ACCOUNT_NUMBER_FIELD_NAME_NORMALIZED = 'CANCheck.AccountNumber';
CANCheck.BANK_NUMBER_FIELD_NAME = 'BankNumber';
CANCheck.BANK_NUMBER_FIELD_NAME_NORMALIZED = 'CANCheck.BankNumber';
CANCheck.CHEQUE_NUMBER_FIELD_NAME = 'ChequeNumber';
CANCheck.CHEQUE_NUMBER_FIELD_NAME_NORMALIZED = 'CANCheck.ChequeNumber';
CANCheck.DESIGNATION_NUMBER_FIELD_NAME = 'DesignationNumber';
CANCheck.DESIGNATION_NUMBER_FIELD_NAME_NORMALIZED = 'CANCheck.DesignationNumber';
CANCheck.TRANSACTION_CODE_FIELD_NAME = 'TransactionCode';
CANCheck.TRANSACTION_CODE_FIELD_NAME_NORMALIZED = 'CANCheck.TransactionCode';
CANCheck.TRANSIT_NUMBER_FIELD_NAME = 'TransitNumber';
CANCheck.TRANSIT_NUMBER_FIELD_NAME_NORMALIZED = 'CANCheck.TransitNumber';
/** A check that doesn't conform to any supported standard */
export class UnknownCheck extends Check {
    constructor(document) {
        super(document);
    }
    requiredDocumentType() {
        return UnknownCheck.DOCUMENT_TYPE;
    }
}
UnknownCheck.DOCUMENT_TYPE = 'UnknownCheck';
//# sourceMappingURL=CheckDocumentModel.js.map